import request from 'oc-request';

export const createBubbleMenuFeatures = (editor) => {
  let bubbleMenu = null;
  let alpineInitialized = false;

  // Определяем Alpine.js компонент
  window.bubbleMenuData = () => ({
    mode: 'selection',
    userRequest: '',
    isLoading: false,
    responseText: '',
    
    init() {
      window.bubbleMenuAlpine = this;
    },
    
    insertText() { 
      this.insertBlock(this.responseText);

      this.flushBubbleMenu();
    },

    runPrompt() {
      if (this.mode == 'space') {
        this.runSpacePrompt();
      } else if (this.mode == 'selection') {
        this.runSelectionPrompt();
      }
    },

    runSpacePrompt() {
      this.isLoading = true;

      request.sendData('DocumentManager::onCustomPrompt', {
        data: { prompt: this.userRequest, type: 'space' },
        loading: '.preloader-selector',

        success: (response) => {
          this.isLoading = false;

          this.responseText = response.result;
        },

        error: (xhr) => {
          alert('Произошла ошибка при выполнении запроса');
        }
      });
    },

    runSelectionPrompt() {

      this.isLoading = true;

      const { from, to } = editor.state.selection;
      const text = editor.state.doc.textBetween(from, to);

      request.sendData('DocumentManager::onCustomPrompt', {
        data: { prompt: this.userRequest, context: text, type: 'select' },
        loading: '.preloader-selector',

        success: (response) => {
          this.isLoading = false;
          this.updateText(response.result, { from, to });
        },

        error: (xhr) => {
          alert('Произошла ошибка при выполнении запроса');
        }
      });

    },

    continueText() { 
      this.isLoading = true;

      // Сохраняем текущую позицию
      const originalSelection = editor.state.selection;
      
      // Получаем предыдущий узел
      const canGoBack = editor.commands.selectNodeBackward();
      
      let previousText = '',
          previousNodeType = '';
      
      if (canGoBack) {
        // Если смогли перейти назад, получаем текст и тип выделенного узла
        const { from, to } = editor.state.selection;
        const node = editor.state.doc.nodeAt(from);
        
        previousText = editor.state.doc.textBetween(from, to);
        previousNodeType = node.type.name; // Например: 'paragraph', 'heading', etc.
        
        // Если это заголовок, получаем его уровень
        const headingLevel = node.attrs.level;
        if (headingLevel) {
          previousNodeType = `heading-${headingLevel}`; // например: 'heading-1', 'heading-2'
        }
        
        // Возвращаемся к исходной позиции
        editor.commands.setTextSelection(originalSelection.from);
      }
      console.log(previousText, previousNodeType);
      request.sendData('DocumentManager::onContentAppend', {
        data: { 
          content: previousText,
          type: previousNodeType
        },
        loading: '.preloader-selector',

        success: (response) => {
          this.isLoading = false;
          
          this.responseText = response.text;
        },

        error: (xhr) => {
          this.isLoading = false;
          alert('Произошла ошибка при выполнении запроса');
        }
      });

      return;
    },

    reText() {
      const { from, to } = editor.state.selection;
      const text = editor.state.doc.textBetween(from, to);
      this.isLoading = true;

      request.sendData('DocumentManager::onTextGenerate', {
        data: { old_text: text, method: 'rewrite' },
        loading: '.preloader-selector',

        success: (response) => {
          this.isLoading = false;
          this.updateText(response.text, { from, to });

          this.flushBubbleMenu();
        },

        error: (xhr) => {
          alert('Произошла ошибка при выполнении запроса');
        }
      });
    },

    smallText() {
      const { from, to } = editor.state.selection;
      const text = editor.state.doc.textBetween(from, to);
      this.isLoading = true;

      request.sendData('DocumentManager::onTextGenerate', {
        data: { old_text: text, method: 'small' },
        loading: '.preloader-selector',
    
        success: (response) => {
          this.isLoading = false;
          this.updateText(response.text, { from, to });

          this.flushBubbleMenu();
        },
    
        error: (xhr) => {
          alert('Произошла ошибка при выполнении запроса');
        }
      });
    },

    bigText() {
      const { from, to } = editor.state.selection;
      const text = editor.state.doc.textBetween(from, to);
      this.isLoading = true;

      request.sendData('DocumentManager::onTextGenerate', {
        data: { old_text: text, method: 'big' },
        loading: '.preloader-selector',
    
        success: (response) => {
          this.isLoading = false;
          this.updateText(response.text, { from, to });

          this.flushBubbleMenu();
        },
    
        error: (xhr) => {
          alert('Произошла ошибка при выполнении запроса');
        }
      });
    }
  });

  const features = {
    createBubbleMenu() {
      bubbleMenu = document.createElement('div');
      bubbleMenu.classList.add('bubble-menu');
      
      bubbleMenu.innerHTML = `
      <div x-data="bubbleMenuData" class="z-10">

        <div class="bg-base-100/50 absolute start-0 top-0 size-full" x-show="isLoading"></div>

        <div class="absolute z-10 start-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform" x-show="isLoading">
          <span class="loading loading-infinity"></span>
        </div>

        <div x-show="responseText.length" class="relative bg-muted panel panel--sm text-sm border-b-0">
          <div x-html="responseText"></div>
        </div>

        <div class="ai-content" x-show="!responseText.length">
          <div class="relative bg-muted">

            <textarea class="input shadow w-full resize-none overflow-hidden text-left pt-1" rows="3" x-model="userRequest" :disabled="isLoading" placeholder="Введите prompt" @input="$el.style.height = ''; $el.style.height = $el.scrollHeight + 'px'" style="min-height: 80px;"></textarea>
            
            <div class="absolute right-1 top-1.5">
              <button class="btn btn-primary btn-xs" @click.prevent="runPrompt" :disabled="isLoading">
                <span class="icon-[tabler--corner-up-right] color-white size-5"></span>
              </button>
            </div>

          </div>
        </div>

        <div class="p-1 w-112">
            <div class="ai-actions bg-muted inline-block w-60 p-1.5">

              <div x-show="responseText.length">
                <button class="bubble-menu-item w-full" @click.prevent="insertText">
                  <span class="text-green-600 icon-[tabler--check] mr-2"></span>
                  Применить
                </button>

                <button class="bubble-menu-item w-full" @click.prevent="responseText = ''">
                  <span class="text-red-600 icon-[tabler--x] mr-2"></span>
                  Очистить
                </button>
              </div>
              
              <div x-show="mode === 'space' && !responseText.length">
                  <button class="bubble-menu-item w-full" @click.prevent="continueText">
                    Продолжить
                  </button>
              </div>

              <div x-show="mode === 'selection' && !responseText.length">
                <div class="ai-actions bg-muted inline-block w-full p-1.5">
                  <span class="bubble-menu-item" @click="reText">
                    <span class="icon-[tabler--sparkles] mr-2"></span>
                    Оптимизировать
                  </span>

                  <span class="bubble-menu-item" @click="smallText">              
                    <span class="icon-[tabler--align-justified] mr-2"></span>
                    Сократить
                  </span>

                  <span class="bubble-menu-item" @click="bigText">
                    <span class="icon-[tabler--baseline-density-medium] mr-2"></span>
                    Развернуть
                  </span>          
                </div>
              </div>
              
            </div>
        </div>

      </div>`;

      const editorContainer = editor.view.dom.closest('.relative');
      editorContainer.appendChild(bubbleMenu);

      setTimeout(() => {
        alpineInitialized = true;
      }, 100);

      return bubbleMenu;
    },

    showBubbleMenuIfNeeded(mode = 'selection') {
      if (!bubbleMenu) return;

      if (!alpineInitialized) {
        setTimeout(() => {
          this.showBubbleMenuIfNeeded(mode);
        }, 50);
        return;
      }

      let rect;
      
      if (mode === 'selection') {
        const selection = window.getSelection();
        if (!selection.rangeCount) return;
        rect = selection.getRangeAt(0).getBoundingClientRect();
      } else {
        const { $from } = editor.state.selection;
        rect = editor.view.coordsAtPos($from.pos);
      }
      
      if (!rect || (rect.width === 0 && mode === 'selection')) return;

      if (window.bubbleMenuAlpine) {
        window.bubbleMenuAlpine.mode = mode;
      }

      // Получаем позицию контейнера
      const editorContainer = editor.view.dom.closest('.relative');
      const containerRect = editorContainer.getBoundingClientRect();

      // Корректируем позицию относительно контейнера
      const top = rect.bottom - containerRect.top;
      
      bubbleMenu.style.top = `${top}px`;
      bubbleMenu.style.display = 'block';

      // Устанавливаем фокус на input
      if (mode === 'space') {
        setTimeout(() => {
          const input = bubbleMenu.querySelector('input');
          if (input) {
            input.focus();
          }
        }, 0);
      }
    },

    hideBubbleMenu() {
      if (!bubbleMenu) return;
      bubbleMenu.style.display = 'none';
    },

    flushBubbleMenu() {
      if (!bubbleMenu) return;

      // Сначала скрываем меню
      this.hideBubbleMenu();
      this.responseText = '';
      this.userRequest = '';
      editor.view.dom.removeEventListener('click', this.handleDocumentClick);
    },

    destroy() {

      if (!bubbleMenu) return;

      // Сначала скрываем меню
      this.hideBubbleMenu();
      
      // Удаляем все обработчики событий
      editor.view.dom.removeEventListener('click', this.handleDocumentClick);
      
      // Очищаем Alpine.js компонент
      if (window.bubbleMenuAlpine) {
        window.bubbleMenuAlpine.$destroy?.();
        window.bubbleMenuAlpine = null;
      }
      
      // Удаляем DOM элемент
      setTimeout(() => {
        bubbleMenu.remove();
        bubbleMenu = null;
        alpineInitialized = false;
      }, 150);

    }
  };

  return features;
};
